import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import { AgentButton } from "./components/agent/agent-button";
import { AppLayout } from "./components/layout/app-layout";
import { ProtectedRoute } from "./components/layout/protected-route";
import { AgentProvider } from "./contexts/agent";
import { AuthProvider } from "./contexts/auth";
import { QueryProvider } from "./contexts/query";
import { CommsPage } from "./pages/comms";
import { DashboardPage } from "./pages/dashboard";
import { InsuranceFormPage } from "./pages/insurance-form";
import { InsuranceListPage } from "./pages/insurance-list";
import { InsuranceViewPage } from "./pages/insurance-view";
import { SettingsPage } from "./pages/settings";

export function App(): React.ReactElement {
  return (
    <QueryProvider>
      <AuthProvider>
        <BrowserRouter>
          <AgentProvider>
            <Routes>
              <Route
                element={
                  <ProtectedRoute>
                    <AppLayout />
                  </ProtectedRoute>
                }
              >
                <Route path="/" element={<DashboardPage />} />
                <Route path="/insurance" element={<InsuranceListPage />} />
                <Route path="/insurance/new" element={<InsuranceFormPage />} />
                <Route path="/insurance/:id" element={<InsuranceViewPage />} />
                <Route path="/insurance/:id/edit" element={<InsuranceFormPage />} />
                <Route path="/settings" element={<SettingsPage />} />
                <Route path="/settings/property-types" element={<SettingsPage />} />
                <Route path="/settings/subsoil-options" element={<SettingsPage />} />
                <Route path="/settings/valuers" element={<SettingsPage />} />
                <Route path="/settings/defaults" element={<SettingsPage />} />
                <Route path="/settings/users" element={<SettingsPage />} />
                <Route path="/settings/what-the-ai-knows" element={<SettingsPage />} />
                <Route path="/comms" element={<CommsPage />} />
                <Route path="/comms/audiences" element={<CommsPage />} />
              </Route>
            </Routes>
            <AgentButton />
            <Toaster position="bottom-left" richColors />
          </AgentProvider>
        </BrowserRouter>
      </AuthProvider>
    </QueryProvider>
  );
}
